module.exports = __webpack_public_path__ + "img/shine-green.822a1989.png";